import cx from 'classnames'

export const controlClassName = cx(
  'tw:block tw:h-[var(--ds-control-height)] tw:w-full tw:rounded-input tw:border tw:border-strong tw:bg-surface tw:px-3 tw:py-2',
  'tw:text-base tw:text-foreground tw:placeholder:text-foreground-subtle',
  'tw:transition-[border-color,box-shadow] tw:duration-fast tw:ease-standard',
  'tw:focus:border-focus tw:focus:outline-transparent tw:focus:shadow-focus-input',
  'tw:disabled:cursor-not-allowed tw:disabled:bg-surface-subtle tw:disabled:opacity-70',
)
